import React, { useEffect } from "react";
import { useLocation } from "react-router";
import { useHistory } from "@core/routing/useHistory";
import styled from "styled-components";
import { Path } from "@core/routing/path";
import { useServices } from "@core/servicesContext";
import { useRegisterState } from "@domain/currentProfile/hooks";
import { RegisterState } from "@domain/currentProfile/registerState";
import { CloseButton } from "@ui/modals/closeButton";
import type { AuthLocationState } from "@ui/pages/loginPage/authPage";
import { LoginForm } from "@ui/pages/loginPage/loginForm";
import { DeleteIcon } from "@ui/components/icons";

interface AuthModalProps extends React.HTMLAttributes<HTMLDivElement> {
	close: () => void;
}

export const AuthModal: React.FC<AuthModalProps> = ({ close, ...htmlProps }) => {
	const history = useHistory();
	const { currentProfileService } = useServices();
	const location = useLocation();
	const registerState = useRegisterState();

	useEffect(() => {
		if (registerState !== RegisterState.LOGOUT) {
			close();
		}
	}, [registerState]);

	return (
		<Container {...htmlProps}>
			<CloseButton onClick={() => close()}>
				<DeleteIcon />
			</CloseButton>
			<LoginForm
				onSignup={() => {
					currentProfileService.setPostLoginLocation(location.pathname);
					history.push(Path.Root, { initialMode: "signup" } satisfies AuthLocationState);
					close();
				}}
			/>
		</Container>
	);
};

const Container = styled.div`
	position: relative;
	width: min(440px, 100%);
	padding: 48px 32px 32px;
	border-radius: 20px;
	background: ${({ theme }) => theme.colors.white};
`;
